export default __webpack_public_path__ + "static/search-bottom-tablet-9e178c02c4af71a1ccd54d0836d88148.jpg";